import { Injectable } from '@angular/core';
import { GermplasmPairModel } from './model/germplasm-pair.model';
import { GermplasmPairTraitModel } from './model/germplasm-pair-trait.model';
import { TrialEnvironmentSearchResponse } from '../shared/query/model/trial-environment-search-response.model';

@Injectable()
export class HeadToHeadQueryContext {
    germplasmPairs: GermplasmPairModel[] = [];
    standardGIDs: Set<number> = new Set();
    testEntryGIDS: Set<number> = new Set();
    traits: GermplasmPairTraitModel[] = [];
    environments: TrialEnvironmentSearchResponse[] = [];
}